'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const UserInfo=require('../../../../../dist-es6/client/dtos/userInfo');let

UserCreatedModalController=function(_BaseController){_inherits(UserCreatedModalController,_BaseController);_createClass(UserCreatedModalController,null,[{key:'$inject',get:function()
{
return['$modalInstance','uncaughtErrorHandler','user'];
}}]);

function UserCreatedModalController($modalInstance,uncaughtErrorHandler,user){_classCallCheck(this,UserCreatedModalController);
_.ensureInstanceOf(UserInfo,user);var _this=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler));

_this._$modalInstance=$modalInstance;
_this._user=user;return _this;
}UserCreatedModalController.prototype.





onOk=function onOk(){
this._$modalInstance.close();
};_createClass(UserCreatedModalController,[{key:'user',get:function(){return this._user}}]);return UserCreatedModalController}(BaseController);


module.exports=UserCreatedModalController;
//# sourceMappingURL=userCreatedModalController.js.map
